"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePodConnectionStatus = void 0;
// eslint-disable-next-line import/prefer-default-export
var parsePodConnectionStatus = function (dataView) {
    try {
        return {
            connected: !!dataView.getUint8(0),
            podType: dataView.getUint8(1),
            podUid: 'UUID POD',
            liquidFlavor: dataView.getUint16(7),
            podCapacity: dataView.getUint8(9),
            liquidNicotineStrength: dataView.getUint8(10),
            volumeOfLiquidRemaining: dataView.getUint16(11),
        };
    }
    catch (_a) {
        return {
            connected: !!(dataView === null || dataView === void 0 ? void 0 : dataView.getUint8(0)),
        };
    }
};
exports.parsePodConnectionStatus = parsePodConnectionStatus;
